<template>

  <div class="body">
    <div class="search">
      <!-- 时间筛选 -->
      <span>{{ $t('message.timeFilterSelection') }}:</span>
      <div class="item">
        <el-date-picker v-model="year" type="year" value-format="yyyy">
        </el-date-picker>
      </div>
      <el-button type="primary" @click="totalCache">{{ $t('message.search') }}</el-button>
    </div>
    <!-- 统计数据 -->
    <div class="statisticalData">
      <!-- 商品数据 -->
      <div class="productData">
        <div class="name">
          {{ $t('message.productData') }}
        </div>
        <div class="list">
          <!-- 1688采购链接数 -->
          <div class="item">
            <div class="img">
              <img src="@/assets/icon/1688.png" alt="">
            </div>
            <div class="status-box">
              <div class="status-name"> {{ $t('message.procurementLinkQuantity') }}</div>
              <div class="status-num">{{ totalCacheData.Total.K_1688_count }}</div>
            </div>
          </div>
          <!-- 1688采购总金额 -->
          <div class="item">
            <div class="img">
              <img src="@/assets/icon/1688.png" alt="">
            </div>
            <div class="status-box">
              <div class="status-name">{{ $t('message.procurementTotalAmount') }}</div>
              <div class="status-num">{{ totalCacheData.Total.K_1688_amount_RMB }}元</div>
            </div>
          </div>
          <!-- 淘宝采购链接数量 -->
          <div class="item">
            <div class="img">
              <img src="@/assets/icon/taobao.png" alt="">
            </div>
            <div class="status-box">
              <div class="status-name">{{ $t('message.taobaoProcurementLinkQuantity') }}</div>
              <div class="status-num">{{ totalCacheData.Total.K_taobao_count }}</div>
            </div>
          </div>
          <!-- 淘宝采购总金额 -->
          <div class="item">
            <div class="img">
              <img src="@/assets/icon/taobao.png" alt="">
            </div>
            <div class="status-box">
              <div class="status-name">{{ $t('message.taobaoProcurementTotalAmount') }}</div>
              <div class="status-num">{{ totalCacheData.Total.K_taobao_shop_count }}元</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 工厂数据  -->
      <div class="factoryData">
        <div class="name">
          {{ $t('message.factoryData') }}
        </div>
        <div class="list">
          <!-- 采购过的1688工厂数量 -->
          <div class="item">
            <div class="img">
              <img src="@/assets/icon/factory.png" alt="">
            </div>
            <div class="status-box">
              <div class="status-name"> {{ $t('message.numberOf1688FactoriesProcured') }}</div>
              <div class="status-num">{{ totalCacheData.Total.K_1688_shop_count }}</div>
            </div>
          </div>
          <!-- 采购过的淘宝工厂数量 -->
          <div class="item">
            <div class="img">
              <img src="@/assets/icon/factory.png" alt="">
            </div>
            <div class="status-box">
              <div class="status-name">{{ $t('message.numberOfTaobaoFactoriesProcured') }}</div>
              <div class="status-num">{{ totalCacheData.Total.K_taobao_shop_count }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 私密货盘-->
      <div class="factoryData" v-if="false">
        <div class="name">
          {{ $t('message.confidentialProductList') }}
        </div>
        <div class="list">
          <!-- 已抓取店铺数 -->
          <div class="item">
            <div class="img">
              <!-- <img src="@/assets/icon/购买中.png" alt=""> -->
            </div>
            <div class="status-box">
              <div class="status-name"> {{ $t('message.numberOfStoresCrawled') }}</div>
              <div class="status-num">1</div>
            </div>
          </div>
          <!-- 已抓取私密商品链接数量 -->
          <div class="item">
            <div class="img">
              <!-- <img src="@/assets/icon/等待发货.png" alt=""> -->
            </div>
            <div class="status-box">
              <div class="status-name">{{ $t('message.numberOfConfidentialProductLinksCrawled') }}</div>
              <div class="status-num">1</div>
            </div>
          </div>

        </div>

      </div>
    </div>
    <!-- 按商品统计下单排名 -->
    <div class="orderRankingByProductStatistics">
      <div class="search">
        <span>{{ $t('message.orderRankingByProductStatistics') }}</span>
        <div class="item">
          <el-select v-model="productData.type" placeholder="请选择">
            <el-option v-for="item in options" :key="item.typeProduct" :label="item.label" :value="item.typeProduct">
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <el-select v-model="productData.size" placeholder="请选择">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-button type="primary" @click="setProductData">{{ $t('message.search') }}</el-button>
        <el-button @click="resetProductData">{{ $t('message.reset') }}</el-button>
        <div class="btn">
          <!-- EXCEL导出  -->
          <el-button type="success" @click="totalCacheExport(productData)">{{ $t('message.excelExport') }}</el-button>
        </div>
      </div>
      <div class="table">
        <ol>
          <!-- 排名 -->
          <li class="flex05">{{ $t('message.ranking') }}</li>
          <!-- 商品链接 -->
          <li class="flex2">{{ $t('message.ProductLink') }}</li>
          <!-- 所属平台 -->
          <li>{{ $t('message.platformAffiliation') }}</li>
          <!-- 工厂名 -->
          <li>{{ $t('message.factoryName') }}</li>
          <!-- 商品名称 -->
          <li>{{ $t('message.productName') }}</li>
          <!-- 商品图片 -->
          <li>{{ $t('message.productPicture') }}</li>
          <!-- 最后一次采购日期 -->
          <li>{{ $t('message.lastPurchaseDate') }}</li>
          <!-- 历史采购次数 -->
          <li>{{ $t('message.historicalPurchaseCount') }}</li>
          <!-- 历史采购总金额 -->
          <li>{{ $t('message.totalHistoricalPurchaseAmount') }}</li>
        </ol>
        <ul v-for="(item, index) in productData.list" :key="index" v-show="productData.size > index">
          <!-- 排名 -->
          <li class="flex05">{{ index + 1 }}</li>
          <!-- 商品链接 -->
          <li class="flex2">
            <p>
              <a :href="`https://www.rakumart.com/ProductDetails?goods_id=${item.goods_id}&fromPlatform=${item.from_platform}`"
                target="_blank" rel="noopener noreferrer" class="a-link">
                {{
                  `https://www.rakumart.com/ProductDetails?goods_id=${item.goods_id}&fromPlatform=${item.from_platform}`
                }}
              </a>
            </p>
          </li>
          <!-- 所属平台 -->
          <li>{{ item.from_platform }}</li>
          <!-- 工厂名 -->
          <li>{{ item.shop_name }}</li>
          <!-- 商品名称 -->
          <li>{{ item.goods_title }}</li>
          <!-- 商品图片 -->
          <li>
            <el-image style="width: 80px;height: 80px;border-radius: 6px; " :src="item.pic"
              :preview-src-list="[item.pic]">
            </el-image>
          </li>
          <!-- 最后一次采购日期 -->
          <li>{{ item.last_order }}</li>
          <!-- 历史采购次数 -->
          <li>{{ item.order_count }}</li>
          <!-- 历史采购总金额 -->
          <li style="cursor: pointer;" @click="goodsIdDetail(item)">{{ item.amount }}元</li>
        </ul>
      </div>
    </div>
    <!-- 按工厂统计下单排名 -->
    <div class="orderRankingByProductStatistics">
      <div class="search">
        <span>{{ $t('message.rankingByFactoryOrderStatistics') }}</span>
        <div class="item">
          <el-select v-model="factoryData.type" placeholder="请选择">
            <el-option v-for="item in options" :key="item.typeFactory" :label="item.label" :value="item.typeFactory">
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <el-select v-model="factoryData.size" placeholder="请选择">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-button type="primary" @click="setFactoryData">{{ $t('message.search') }}</el-button>
        <el-button @click="resetFactoryData">{{ $t('message.reset') }}</el-button>
        <div class="btn">
          <!-- EXCEL导出  -->
          <el-button type="success" @click="totalCacheExport(factoryData)">{{ $t('message.excelExport') }}</el-button>
        </div>
      </div>
      <div class="table">
        <ol>
          <!-- 排名 -->
          <li class="flex05">{{ $t('message.ranking') }}</li>
          <!-- 工厂名 -->
          <li>{{ $t('message.factoryName') }}</li>
          <!-- 工厂链接 -->
          <li>{{ $t('message.factoryLink') }}</li>
          <!-- 所属平台 -->
          <li>{{ $t('message.platformAffiliation') }}</li>
          <!-- 最后一次采购日期 -->
          <li>{{ $t('message.lastPurchaseDate') }}</li>
          <!-- 历史采购次数 -->
          <li>{{ $t('message.historicalPurchaseCount') }}</li>
          <!-- 历史采购总金额 -->
          <li>{{ $t('message.totalHistoricalPurchaseAmount') }}</li>
        </ol>
        <ul v-for="(item, index) in factoryData.list" :key="index" v-show="factoryData.size > index">
          <!-- 排名 -->
          <li class="flex05">{{ index + 1 }}</li>
          <!-- 工厂名 -->
          <li>{{ item.shop_name }}</li>
          <!-- 工厂链接 -->
          <li>
            <p>
              <a :href="`https://www.rakumart.com/ProductDetails?goods_id=${item.goods_id}&fromPlatform=${item.from_platform}`"
                target="_blank" rel="noopener noreferrer" class="a-link">
                {{
                  `https://www.rakumart.com/ProductDetails?goods_id=${item.goods_id}&fromPlatform=${item.from_platform}`
                }}
              </a>
            </p>

          </li>
          <!-- 所属平台 -->
          <li>{{ item.from_platform }}</li>
          <!-- 最后一次采购日期 -->
          <li>{{ item.last_order }}</li>
          <!-- 历史采购次数 -->
          <li>{{ item.order_count }}</li>
          <!-- 历史采购总金额 -->
          <li style="cursor: pointer;" @click="goodsIdDetail(item)">{{ item.amount }}</li>
        </ul>
      </div>
    </div>
    <!-- 查个单个详情 -->
    <el-dialog :visible.sync="dialogVisible" width="700px">
      <div class="table">
        <ol>
          <li>客户信息</li>
          <li>采购次数</li>
          <li>采购金额-元</li>
        </ol>
        <ul v-for="(item, index) in goodsIdDetailData" :key="index">
          <li>
            <div style="width: 100%; text-align: center;">
              <p>ID:{{ item.user_id }}</p>
              {{ item.realname }}
            </div>
          </li>
          <li> {{ item.order_sn }}</li>
          <li> {{ item.amount }}</li>
        </ul>
        <div class="nodata" v-if="goodsIdDetailData == false">暂无数据</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      year: '2025',
      productData: {
        type: 'Top500ById_all',
        size: '100',
        list: [],
      },
      factoryData: {
        type: 'Top500ByShop_all',
        size: '100',
        list: [],
      },
      options: [
        { label: '全部平台', value: '全部平台', typeProduct: 'Top500ById_all', typeFactory: 'Top500ByShop_all' },
        { label: '1688', value: '1688', typeProduct: 'Top500ById_1688', typeFactory: 'Top500ByShop_1688' },
        { label: '淘宝', value: 'taobao', typeProduct: 'Top500ById_taobao', typeFactory: 'Top500ByShop_taobao' },
        { label: 'RAKUMART', value: 'RAKUMART', typeProduct: 'Top500ById_rakumart', typeFactory: 'Top500ByShop_rakumart' },
      ],
      options1: [
        { label: '前100条', value: '100' },
        { label: '前300条', value: '300' },
        { label: '前500条', value: '500' },

      ],
      totalCacheData: {
        Total: {}
      },
      goodsIdDetailData: [], //商品ID查看明细
      dialogVisible: false
    };
  },
  created() {
    this.totalCache()
  },
  methods: {
    totalCache() {
      this.$api.productManagementApi.totalCache({ year: this.year }).then(res => {
        this.totalCacheData = res.data
        this.setProductData()
        this.setFactoryData()
        console.log(res);

      })
    },
    // 商品设置
    setProductData() {
      this.productData.list = this.totalCacheData[this.productData.type]
    },
    //商品重置
    resetProductData() {
      this.productData = {
        type: 'Top500ById_all',
        size: '100',
        list: [],
      }
      this.setProductData()
    },
    //工厂设置
    setFactoryData() {
      this.factoryData.list = this.totalCacheData[this.factoryData.type]
    },
    //工厂重置
    resetFactoryData() {
      this.factoryData = {
        type: 'Top500ByShop_all',
        size: '100',
        list: [],
      }
      this.setFactoryData()
    },
    //商品数据分析-导出excel
    totalCacheExport(data) {
      let datas = {
        year: this.year,
        exportKey: data.type,
      }
      this.$api.productManagementApi.totalCacheExport(datas).then(res => {
        const a = document.createElement('a');
        const href = res.data
        a.href = href;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); // 下载完移除元素


      })
    },
    //商品ID查看明细
    goodsIdDetail(item) {
      let datas = {
        year: this.year,
        goods_id: item.goods_id,
        from_platform_set: [item.from_platform]
      }
      this.$api.productManagementApi.goodsIdDetail(datas).then(res => {
        this.goodsIdDetailData = res.data
        this.dialogVisible = true
        console.log(res);

      })
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  position: relative;

  span {
    font-size: 20px;
    margin-right: 24px;
    line-height: 40px;
    font-weight: bold;
  }

  .item {
    margin-right: 24px;

  }

  .btn {
    position: absolute;
    top: 0;
    right: 0
  }

}

.statisticalData {
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 24px;
  display: flex;
  margin: 24px 0;

  .name {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 24px;
  }

  .productData {
    flex: 2;

  }

  .factoryData {
    flex: 1;
    border-left: 1px solid #ccc;
    padding-left: 30px;
  }

  .list {
    display: flex;
    padding: 0 10px;

    .item {
      display: flex;
      margin-right: 24px;

      &:nth-last-child(1) {
        margin-right: 0;
      }

      .img {
        padding: 14px;
        background-color: #fff;
        box-shadow: 0px 6px 10px 0px rgba(96, 113, 146, 0.1);
        border-radius: 10px;
        margin-right: 10px;
        cursor: pointer;

        img {
          width: 32px;
          height: 32px;
        }
      }

      .status-box {
        .status-name {
          font-size: 14px;
          color: #333333;
          height: 40px;
          line-height: 20px;
        }

        .status-num {
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          line-height: 20px;
        }
      }
    }
  }
}

.orderRankingByProductStatistics {
  padding: 24px;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-bottom: 48px;


}

.table {
  margin: 24px 0;
  max-height: 600px;
  overflow-y: auto;
  position: relative;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;
  }

  li {
    margin: 0 5px;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex2 {
    flex: 2;
  }
}
</style>